import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as p } from "../../../../IconBase-CxZyIWw2.js";
const i = r(
  (o, t) => /* @__PURE__ */ s.jsx(
    p,
    {
      ref: t,
      ...o,
      image: (e) => /* @__PURE__ */ s.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 3375,
          height: 2125,
          fill: "none",
          viewBox: "0 0 3375 2125",
          ...e,
          children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "url(#paint0_linear_2_415)",
                d: "M2404.28 1290.18h204.28c5.84 0 19.46-1.95 25.29-1.95 38.91-7.78 71.99-42.81 71.99-91.46 0-46.7-33.08-81.73-71.99-91.46-5.83-1.94-17.51-1.94-25.29-1.94h-204.28z"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "url(#paint1_linear_2_415)",
                d: "M2585.21 0c-194.55 0-354.08 157.624-354.08 354.167v367.788h500c11.67 0 25.29 0 35.02 1.946 112.84 5.838 196.49 64.217 196.49 165.408 0 79.784-56.42 147.891-161.47 161.511v3.9c114.78 7.78 202.33 72 202.33 171.24 0 107.03-97.28 177.09-225.68 177.09h-548.63v720h519.45c194.55 0 354.08-157.62 354.08-354.16V0z"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "url(#paint2_linear_2_415)",
                d: "M2680.54 912.66c0-46.703-33.07-77.839-71.98-83.676-3.89 0-13.62-1.946-19.45-1.946h-184.83v171.245h184.83c5.83 0 17.51 0 19.45-1.946 38.91-5.838 71.98-36.973 71.98-83.677"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "url(#paint3_linear_2_415)",
                d: "M628.029 0C433.478 0 273.946 157.624 273.946 354.167v873.743c99.221 48.65 202.333 79.78 305.445 79.78 122.567 0 188.715-73.94 188.715-175.14V720.009h303.504v410.601c0 159.57-99.226 289.95-435.799 289.95-204.279 0-363.811-44.76-363.811-44.76v745.31h519.452c194.551 0 354.088-157.63 354.088-354.17V0z"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                fill: "url(#paint4_linear_2_415)",
                d: "M1606.62 0c-194.55 0-354.08 157.624-354.08 354.167v463.141c89.49-75.893 245.13-124.542 496.1-112.867 134.24 5.838 278.21 42.812 278.21 42.812v149.839c-71.98-36.973-157.58-70.054-268.48-77.838-190.66-13.622-305.44 79.785-305.44 243.246 0 165.41 114.78 258.81 305.44 243.25 110.9-7.79 196.5-42.81 268.48-77.84v149.84s-142.02 36.97-278.21 42.81c-250.97 11.67-406.61-36.97-496.1-112.87V2125h519.45c194.55 0 354.08-157.62 354.08-354.17V0z"
              }
            ),
            /* @__PURE__ */ s.jsxs("defs", { children: [
              /* @__PURE__ */ s.jsxs(
                "linearGradient",
                {
                  id: "paint0_linear_2_415",
                  x1: 2230.81,
                  x2: 3105.07,
                  y1: 1197,
                  y2: 1197,
                  gradientUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ s.jsx("stop", { stopColor: "#007940" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.229, stopColor: "#00873F" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.743, stopColor: "#40A737" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#5CB531" })
                  ]
                }
              ),
              /* @__PURE__ */ s.jsxs(
                "linearGradient",
                {
                  id: "paint1_linear_2_415",
                  x1: 2230.78,
                  x2: 3105.11,
                  y1: 1060.68,
                  y2: 1060.68,
                  gradientUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ s.jsx("stop", { stopColor: "#007940" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.229, stopColor: "#00873F" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.743, stopColor: "#40A737" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#5CB531" })
                  ]
                }
              ),
              /* @__PURE__ */ s.jsxs(
                "linearGradient",
                {
                  id: "paint2_linear_2_415",
                  x1: 2230.78,
                  x2: 3105.08,
                  y1: 912.417,
                  y2: 912.417,
                  gradientUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ s.jsx("stop", { stopColor: "#007940" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.229, stopColor: "#00873F" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.743, stopColor: "#40A737" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#5CB531" })
                  ]
                }
              ),
              /* @__PURE__ */ s.jsxs(
                "linearGradient",
                {
                  id: "paint3_linear_2_415",
                  x1: 273.534,
                  x2: 1161.33,
                  y1: 1060.68,
                  y2: 1060.68,
                  gradientUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ s.jsx("stop", { stopColor: "#1F286F" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.475, stopColor: "#004E94" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.826, stopColor: "#0066B1" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#006FBC" })
                  ]
                }
              ),
              /* @__PURE__ */ s.jsxs(
                "linearGradient",
                {
                  id: "paint4_linear_2_415",
                  x1: 1247.51,
                  x2: 2109.76,
                  y1: 1060.68,
                  y2: 1060.68,
                  gradientUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ s.jsx("stop", { stopColor: "#6C2C2F" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.173, stopColor: "#882730" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.573, stopColor: "#BE1833" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 0.859, stopColor: "#DC0436" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#E60039" })
                  ]
                }
              )
            ] })
          ]
        }
      )
    }
  )
);
i.displayName = "JcbIcon";
export {
  i as JcbIcon,
  i as default
};
//# sourceMappingURL=index.js.map
